import { MODULE_NAME } from '../constants';
export const selectExtensionsList = (state) => state[MODULE_NAME].list;
export const selectInstitutionsList = (state) => state[MODULE_NAME].institutions.sort((a, b) => a.name.localeCompare(b.name));
export const selectExtension = (state) => state[MODULE_NAME].extension;
export const selectStatistics = (state) => state[MODULE_NAME].statistics;
